<template>
  <AbsoluteLayout :class="classes" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @touch="$emit('touch', $event)" :tabindex="isClickable && !hasParentFocus ? 0 : null" :role="isClickable && !hasParentFocus ? 'button' : null" @keydown="handleKeydown">
    <StackLayout class="wrapper" :style="styles">
      <AgCaption :center="center" :dark="dark" noMargin v-if="caption" :text="caption" />
      <slot name="default"></slot>
    </StackLayout>
    <FlexboxLayout class="avatar-wrapper" v-if="avatar" justifyContent="center" alignItems="flex-start" left="0" top="0" width="100%" style="position: absolute; top: 0; left: 0; width: 100%;">
      <FlexboxLayout style="width: 20%;" justifyContent="flex-start">
        <AgButton v-if="back" icon="chevronLeft" color="transparent" iconSize="20" @click="$emit('back', $event)" @tap="$emit('back', $event)" @keydown="handleBackKeydown" aria-label="Zurück" />
      </FlexboxLayout>
      <FlexboxLayout style="width: 60%;" class="avatar-box" justifyContent="center">
        <slot name="avatar"></slot>
      </FlexboxLayout>
      <FlexboxLayout style="width: 20%;" justifyContent="flex-end">
        <AgButton v-if="close" icon="times" color="transparent" iconSize="20" @click="$emit('close', $event)" @tap="$emit('close', $event)" @keydown="handleCloseKeydown" aria-label="Schließen" />
      </FlexboxLayout>
    </FlexboxLayout>
  </AbsoluteLayout>
</template>

<script>

export default {
  props: {
    caption: {
      type: String,
      default: ''
    },
    avatar: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    back: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    background: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes () {
      return {
        'card': true,
        'avatar': this.avatar,
        'modal': this.modal,
        'dark': this.dark,
        'center': this.center
      }
    },
    styles () {
      return {
        'background-color': this.background ? this.background : null
      }
    },
    isClickable () {
      return this.$listeners.tap || this.$listeners.click
    },
    hasParentFocus () {
      return this.$parent && this.$parent.$el && this.$parent.$el.getAttribute('tabindex') !== null
    }
  },
  methods: {
    handleKeydown (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.$emit('click', event)
        this.$emit('tap', event)
      }
    },
    handleBackKeydown (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.$emit('back', event)
      }
    },
    handleCloseKeydown (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.$emit('close', event)
      }
    }
  }
}

</script>

<style scoped lang="scss">

.card {
  &.modal {
    background-color: #9f9f9f;
  }

  & > .wrapper {
    font-family: 'Inter', 'OpenSans-Regular', 'OpenSans Regular';
    background-color: #fff;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
    width: 100%;
  }

  &.modal > .wrapper {
    border-radius: 0;
  }

  .wrapper::v-deep .card-text {
    color: #3b3b3b;
  }

  &.dark > .wrapper::v-deep .card-text {
    color: #ffffff;
  }

  &.center::v-deep {
    text-align: center;
  }

  .wrapper::v-deep .card-content {
    margin: 0;
  }

  .wrapper::v-deep .card-wrapper {
    margin: 0;
  }
}

.ns-ios,
.ns-android {
  .card {
    & > .wrapper {
      border-radius: 8;
      padding-top: 10;
      padding-bottom: 10;
      font-size: 16;
    }

    &.modal > .wrapper {
      border-radius: 0;
    }

    &.avatar > .wrapper {
      padding-top: 70;
      margin-top: 30;
    }

    &.avatar.modal > .wrapper {
      margin-top: 60;
    }

    &.avatar.modal > .avatar-wrapper .avatar-box {
      padding-top: 20;
    }

    .wrapper::v-deep {
      & > .caption {
        padding: 10 20;
      }

      .card-content {
        padding: 0 20;

        & > * {
          margin-top: 10;
          margin-bottom: 10;
        }
      }
    }
  }
}

html {
  .card {

    .avatar-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    & > .wrapper {
      font-size: 16px;
      color: #3b3b3b;
      border-radius: 8px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    &.avatar > .wrapper {
      padding-top: 70px;
      margin-top: 30px;
    }

    &.avatar.modal > .wrapper {
      margin-top: 60px;
    }

    &.avatar.modal > .avatar-wrapper .avatar-box {
      padding-top: 20px;
    }

    .wrapper::v-deep {
      & > .caption {
        padding: 10px 20px;
      }

      .card-content {
        padding: 0 20px;
        
        & > * {
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (min-width: 800px) {
    .card.avatar > .wrapper {
      padding-top: 130px;
    }
  }
}

</style>